import OAWFTrackExtend from './src/list.vue';
/* istanbul ignore next */
OAWFTrackExtend.install = function(Vue) {
  Vue.component('oa-wf-track-extend', OAWFTrackExtend);
};
export default OAWFTrackExtend;


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/track_extend/list/index.js